import { useMediaQuery } from "@mui/material";
import { useContext } from "react";
import StatesContext from "../../context/StatesContext";


const HtmlWithDefaultStyles = ({ htmlString }) => {

  const context = useContext(StatesContext)
  const { darkToggle } = context

  const smallerthen600 = useMediaQuery('(max-width:600px)')


  const defaultStyles = {
    h1: {
      fontSize: '30px',
    },
    h2: {
      fontSize: '23px',
    },
    h3: {
      fontSize: '18px',
    },
    h4: {
      fontSize: '16px',
    },
    p: {
      fontSize: '14px',

    },
    pre: {
      fontSize: '14px',
    },
    blockquote: {
      fontSize: '13px',
      borderLeft: '2px solid black',
      paddingLeft: '10px',
    },
    img: {
      height: smallerthen600 ? '200px' : '300px',
      width: smallerthen600 ? '100%' : '500px',
      borderRadius: '20px',
      objectPosition: 'contain',
      
    },
    span: {
      color: darkToggle && 'white'
    },

  };


  function applyDefaultStyles(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    Object.keys(defaultStyles).forEach((tag) => {
      const elements = doc.getElementsByTagName(tag);
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        Object.assign(element.style, defaultStyles[tag]);
        if (tag === "img") {
          element.addEventListener("mouseover", () => {
            element.classList.add("hoverImg");
          });
          element.addEventListener("mouseout", () => {
            element.classList.remove("hoverImg");
          });
        }
      }
    });
    return doc.documentElement.innerHTML;
  }

  const sanitizedHtmlString = applyDefaultStyles(htmlString);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHtmlString }}
    />
  );
};

export default HtmlWithDefaultStyles;
